<template>
  <div>
    <top-bar fullscreen="true"/>
    <div class="container-login w3-white w3-padding w3-padding-48 w3-round w3-card">
      <div class="w3-center">
        <img class="w3-image" src="/static/imgs/logo-3.png" style="width: 230px"/>
      </div>
      <h6 class="w3-margin-bottom"><b>CodeMarket | Login</b></h6>
      <hr>
      <div v-show="false">
        <h6><b>Não estamos disponíveis no momento!</b></h6>
        <h6>Estamos realizando algumas alterações em nossos servidores. Agradecemos pela compreenção.</h6>
      </div>
      <form @submit.prevent="logar(true)">
        <div class="input-form">
          <input class="w3-light-gray" type="text" v-model="dados.usuario" placeholder="Informe seu usuário" required style="text-transform: lowercase"/>
          <i class="fa fa-user text-primary"></i>
        </div>
        <div class="input-form">
          <input type="password" class="w3-light-gray" v-model="dados.senha" placeholder="Informe sua senha" required min="6"/>
          <i class="fa fa-lock text-primary"></i>
        </div>
        <button type="submit" class="w3-button primary w3-block w3-round login-btn" :disabled="(dados.usuario === '') || (dados.senha === '')">
          Login
        </button>
      </form>
    </div>
  </div>
</template>

<script>
  import TopBar from "../commons/TopBar.vue"

  export default {
    components: {TopBar},
    name: 'Home',
    data() {
      return {
        dados: {
          usuario: '',
          senha: ''
        }
      }
    },
    methods: {
      logar(p) {
        openOnload();

        this.$http.post(base_url + 'autenticar', this.dados, {emulateJSON: true})
          .then(res => {
            localStorage.clear();
            if (res.data.success) {
              localStorage.setItem("key", res.data.token);
              delete res.data.senha;
              localStorage.setItem("usuario", JSON.stringify(res.data));

              setTimeout(() => {
                closeOnload();
                if (res.data.id_funcao === '1') {
                  localStorage.setItem("administrativo", "true");
                }
                this.$router.push("/admin");

              }, 500);

            } else {
              closeOnload()
            }

          }, res => {
            console.log(res);
            closeOnload();
            if (p) {
              openModalMsg(res.data.result,res.data.msg);
            }
          });
      }
    },
    created() {
      if (localStorage.getItem("key")) {
        this.$router.push("/admin/");
      }
    }
  }
</script>

<style scoped>
  .container-login{
    width: 400px;
    margin: 10% auto 0;
    text-align: center;
  }
  .input-form {
    margin: 12px 0 16px;
    border-bottom: 1px solid;
    position: relative;
  }
  .input-form input{
    border: none;
    width: 100%;
    padding: 12px;
    font-size: 1.1em;
  }
  .input-form i {
    position: absolute;
    right: 16px;
    top: 12px;
    font-size: 20px;
  }
  .login-btn {
    margin-top: 32px;
    font-size: 1.1em;
  }

  @media all and (max-width: 600px) {
    .container-login{
      margin: 26% 32px 0;
      width: auto;
    }
  }
</style>




// WEBPACK FOOTER //
// src/components/admin/Login.vue